import React, { Component } from "react";
import Cookies from "universal-cookie";
import MainLayout from "../../components/layouts/MainLayout";
import { withRouter } from "../../hoc/withRouter";
import withAuth from "../../hoc/withAuth";
import { Form, Col, Row, Divider, Transfer, Button, DatePicker, Modal, Select, InputNumber } from "antd";
import { TaxOutGenerateCsvStates } from "./types/TaxOutGenerateCsvTypes";
import { orderService } from "../../services/otodisApi/OrderService";
import { taxOtodisService } from "../../services/otodisApi/TaxOtodisService";
import { CloudSyncOutlined, SaveOutlined } from "@ant-design/icons";
import moment from "moment";

export interface TaxOutGenerateCsvProps {}

class TaxOutGenerateCsv extends Component<TaxOutGenerateCsvProps & any, TaxOutGenerateCsvStates> {
  private token = new Cookies().get("_t");
  private readonly initState!: TaxOutGenerateCsvStates;

  constructor(props: (TaxOutGenerateCsvProps & any) | any) {
    super(props);

    this.initState = {
      submitting: false,
      loading: false,
      dealerCode: props.match.params.dealerCode.replace(/-/g, "#"),
      mockData: [],
      fetchData: [],
      filterOrderStatus: null,
      targetKeys: [],
      fetchLoading: false,
      taxPercentage: 0,
      vatDate: moment().clone().startOf("month").format("YYYY-MM-DD"),
      filterStartDate: moment().clone().startOf("month").format("YYYY-MM-DD"),
      filterEndDate: moment().clone().endOf("month").format("YYYY-MM-DD"),
    };
    this.state = { ...this.initState };
  }

  onDealerChange = async (data: any) => {
    this.setState({
      dealerCode: data.value,
    });
  };

  onStartDate = (data: any) => {
    this.setState({
      filterStartDate: data,
    });
  };

  onEndDate = (data: any) => {
    this.setState({
      filterEndDate: data,
    });
  };

  onVatDate = (data: any) => {
    this.setState({
      vatDate: data,
    });
  };

  onSubmit = async () => {
    await this.promisedSetState({
      submitting: true,
    });

    const orderData: any = [];
    for (const key of this.state.targetKeys) {
      const dataRow = this.state.fetchData[key];
      orderData.push({
        dealer_code: dataRow?.dealer_code,
        order_code: dataRow?.order_code,
        order_discount: dataRow?.order_discount,
        customer_identity_number: dataRow?.customer_identity_number,
        customer_name: dataRow?.customer_name,
        customer_doc_name: dataRow?.customer_doc_name,
        address: dataRow?.address,
        order_delivery_date: dataRow?.order_delivery_date,
        vehicle_variant_name: dataRow?.vehicle_variant_name,
        vehicle_sales_price: dataRow?.vehicle_sales_price,
        transfer_title_cost_real: dataRow?.transfer_title_cost_real,
        order_vat_counter: dataRow?.order_vat_counter,
        order_vat_date: dataRow?.order_vat_date,
        order_vat_number: dataRow?.order_vat_number,
        vehicle_color_code: dataRow?.vehicle_color_code,
        vehicle_engine_number: dataRow?.vehicle_engine_number,
        order_create_date: dataRow?.order_create_date,
        transfer_title_null: dataRow?.transfer_title_null,
      });
    }

    const input = {
      dealer_code: this.state.dealerCode,
      vat_date: moment(this.state.vatDate).format("YYYY-MM-DD"),
      tax_percentage_value: this.state.taxPercentage,
      data_order: orderData,
    };

    try {
      taxOtodisService.setToken(this.token);
      await taxOtodisService.generateCsv(input).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "file.csv");
        document.body.appendChild(link);
        link.click();

        let newSourceData = this.state.mockData.filter((e: any) => !this.state.targetKeys.includes(e.key));
        this.setState({
          targetKeys: [],
          mockData: newSourceData,
          submitting: false,
        });
      });
    } catch (e) {
      Modal.error({
        title: "Proses Gagal",
        content: "Server Menolak Inputan Anda :" + e,
      });
      await this.promisedSetState({
        submitting: false,
      });
    }
  };

  handleChange = (targetKeys: any) => {
    this.setState({ targetKeys });
  };

  fetchOrderData = async () => {
    if (!this.state.filterOrderStatus) {
      Modal.error({
        title: "Proses Gagal",
        content: "Pilih Status",
      });
      return;
    }

    await this.promisedSetState({
      mockData: [],
      fetchData: [],
      targetKeys: [],
      fetchLoading: true,
    });

    const mockDataTemp: any = [];
    orderService
      .getOrder({
        dealerCode: this.state.dealerCode,
        dateStart: moment(this.state.filterStartDate).format("YYYY-MM-DD"),
        dateEnd: moment(this.state.filterEndDate).format("YYYY-MM-DD"),
        dataType: "order_create_date",
        statusOrder: "FINISHED",
        orderVatCounter: this.state.filterOrderStatus,
      })
      .then(async (value) => {
        let counter = 0;
        for (const item of value.data.data) {
          const data = {
            key: counter,
            title: item.order_code,
            description: item.vehicle_engine_number + " | " + item.customer_name,
          };
          counter++;
          mockDataTemp.push(data);
        }
        await this.promisedSetState({
          fetchData: value.data.data,
          mockData: mockDataTemp,
          fetchLoading: false,
        });
      })
      .catch(async (reason) => {
        this.setState({
          fetchData: [],
          mockData: [],
          fetchLoading: false,
        });
        Modal.error({
          title: "Proses Gagal",
          content: "Error :" + reason,
        });
      });
  };

  onFieldChange = <T extends keyof Pick<any, "filterOrderStatus" | "taxPercentage">>(target: T, value: any) => {
    const currentState: any = { ...this.state };
    switch (target) {
      case "filterOrderStatus":
        currentState.filterOrderStatus = value;
        break;
      case "taxPercentage":
        currentState.taxPercentage = value;
        break;
    }
    this.setState({
      ...currentState,
    });
  };

  promisedSetState = (newState: any) => new Promise((resolve: any) => this.setState(newState, resolve));

  render() {
    return (
      <React.Fragment>
        <MainLayout onChangeDealer={this.onDealerChange} breadcrumbPath={`Tax Out`} breadcrumbMenu={`Generate Csv`} defaultSelectedKeys={["m-tax-out-generate-csv"]} defaultOpenKeys={["sm-tax-out"]}>
          <Row>
            <Col xs={24} xl={12}>
              <div className={`mid-pad-10`} style={{}}>
                <Divider>Order Finished</Divider>
                <br />
                <Form layout={`inline`}>
                  <Form.Item style={{ width: "125px" }} label="" className={"padTop-10"}>
                    <i className={`small-text-grey`}>Tgl Awal:</i>
                    <br />
                    <DatePicker defaultValue={moment(this.state.filterStartDate, "YYYY-MM-DD")} onChange={(event) => this.onStartDate(event)} format={"YYYY-MM-DD"} />
                  </Form.Item>
                  <Form.Item style={{ width: "125px" }} label="" className={"padTop-10"}>
                    <i className={`small-text-grey`}>Tgl Akhir:</i>
                    <br />
                    <DatePicker defaultValue={moment(this.state.filterEndDate, "YYYY-MM-DD")} onChange={(event) => this.onEndDate(event)} format={"YYYY-MM-DD"} />
                  </Form.Item>
                  <Form.Item label="" className={"padTop-10"}>
                    <i className={`small-text-grey`}>Status:</i>
                    <br />
                    <Select showSearch placeholder="Pilih Status" optionFilterProp="children" onChange={(value) => this.onFieldChange("filterOrderStatus", value)} value={this.state.filterOrderStatus}>
                      <Select.Option key={`0`} value={`0`}>{`None`}</Select.Option>
                      <Select.Option key={`1`} value={`1`}>{`Generate ULANG`}</Select.Option>
                    </Select>
                  </Form.Item>
                  <Form.Item className={"padTop-10"}>
                    <i className={`small-text-grey`}>&nbsp;</i>
                    <br />
                    <Button loading={this.state.fetchLoading} onClick={this.fetchOrderData} type="primary" icon={<CloudSyncOutlined />}>
                      {" "}
                      Go{" "}
                    </Button>
                  </Form.Item>
                </Form>
              </div>
            </Col>
            <Col xs={24} xl={12}>
              <div className={`mid-pad-10`} style={{ paddingLeft: 17 }}>
                <Divider>Generate CSV</Divider>
                <br />
                <Form layout={`inline`}>
                  <Form.Item label="" className={"padTop-10"}>
                    <i className={`small-text-grey`}>Persentase Pajak:</i>
                    <br />
                    <InputNumber max={100} className={"ant-input"} value={this.state.taxPercentage} onChange={(value) => this.onFieldChange("taxPercentage", value ? parseFloat(value) : 0)} />
                  </Form.Item>
                  <Form.Item label="" className={"padTop-10"}>
                    <i className={`small-text-grey`}>Tgl Faktur:</i>
                    <br />
                    <DatePicker defaultValue={moment(this.state.vatDate, "YYYY-MM-DD")} onChange={(event) => this.onVatDate(event)} format={"YYYY-MM-DD"} />
                  </Form.Item>
                </Form>
              </div>
            </Col>

            <Col span={24}>
              <Transfer
                dataSource={this.state.mockData}
                showSearch
                listStyle={{
                  width: "100%",
                  height: 580,
                }}
                targetKeys={this.state.targetKeys}
                onChange={this.handleChange}
                render={(item) => `${item.title} | ${item.description}`}
              />
            </Col>

            <Col span={24} className={`pad-10`}>
              <Form.Item>
                <Button type={"primary"} icon={<SaveOutlined />} onClick={this.onSubmit} loading={this.state.submitting}>
                  Simpan Data
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </MainLayout>
      </React.Fragment>
    );
  }
}

export default withAuth(withRouter(TaxOutGenerateCsv), 22);
